import Close from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

const PREFIX = 'MetricsDetails';

const classes = {
  paper: `${PREFIX}-paper`,
  close: `${PREFIX}-close`
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.paper}`]: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: '5px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 2, 3),
    outline: 'none',
    minHeight: '400px',
    width: '300px'
  },

  [`& .${classes.close}`]: {
    float: 'right'
  }
}));

type MetricsDetailsProps = {
  elementId: string;
  handleModalClose: () => void;
};

export default function MetricsDetails({ elementId, handleModalClose }: MetricsDetailsProps) {
  return (
    <Root className={classes.paper}>
      <Typography component="span" variant="h6">
        {elementId}
      </Typography>
      <IconButton
        aria-label="close"
        className={classes.close}
        onClick={handleModalClose}
        size="large"
      >
        <Close />
      </IconButton>
      <Typography component="p" variant="body2">
        This modal will contain more detailed information about the metrics of this particular item.
        Possibly a pie chart of my favorite bars and a bar chart of my favorite pies.
      </Typography>
    </Root>
  );
}
